
export default function MenuItem(props){
    return(
        <li>
                <i><span>{props.label}</span></i>
        </li>
    )
}